import {createSlice} from '@reduxjs/toolkit'

export const firebaseSlice = createSlice({
    name: 'firebase',
    initialState: {
        latestSaveSucces: false,
        storedAudioFile: false,
        finalSave: {userData: false, recontact: false, data: false, audio: false},
        allFinalSuccess: false,
        finalAttempts: 0,
        saving: false
    },
    reducers: {
        setSaveSuccess: (state, action) => {
            state.latestSaveSucces = action.payload
        },
        setAudioSuccess: (state, action) => {
            state.storedAudioFile = action.payload
        },
        setFinalSave: (state, action) => {
            state.finalSave = action.payload
            state.allFinalSuccess = Object.values(action.payload).every(v => v)
            state.finalAttempts = state.finalAttempts + 1
        },
        toggleLoading: (state) => {state.saving = !state.saving}
    }
})

export const {
    setSaveSuccess,
    setAudioSuccess,
    setFinalSave,
    toggleLoading
} = firebaseSlice.actions
export default firebaseSlice.reducer